export default "__VITE_ASSET__BrQ3mTTy__"